import React, { useEffect } from "react";
import { Table } from "reactstrap";

export type Ingreso = {
  ingresoUUID: string;
  nroTicket: number;
  fecha: Date;
  ubicacion: string;
  cantidadRollos: string;
  rollosGrabados: string;
};

interface IListadoProps {
  ingresos: Ingreso[];
  itemsPerPage: number;
}
const Listado = (props: IListadoProps) => {
  const { ingresos } = props;
  useEffect(() => {
    console.log("Listado");
    console.log(ingresos);
  }, [ingresos]);
  return (
    <>
      <Table scroll={{ x: 'max-content' }} striped>
        <thead>
          <tr>
            <th>Ticket #</th>
            <th>Ingreso</th>
            <th>Ubicación</th>
            <th>Rollos</th>
          </tr>
        </thead>
        <tbody>
          {ingresos?.map((ingreso: Ingreso) => {
            return (
              <tr key={ingreso.ingresoUUID}>
                <th scope="row">
                  <a href={`/ingresos/${ingreso.ingresoUUID}`}>
                    {ingreso.nroTicket}
                  </a>
                </th>
                <td>{ingreso.fecha.toLocaleDateString()}</td>
                <td>{ingreso.ubicacion}</td>
                <td>{`${ingreso.rollosGrabados} / ${ingreso.cantidadRollos}`}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default Listado;
